import { Model } from '@vuex-orm/core'
import Student from '@/modules/student/models/Student'
import Class from '@/modules/class/models/Class'

export default class ClassInvitation extends Model {
  static entity = 'classInvitations'

  static fields() {
    return {
      id: this.string(''),
      name: this.string(''),
      invitation_code: this.string(''),
      custom_class_id: this.attr(null),
      custom_class: this.belongsTo(Class, 'custom_class_id'),
      student_id: this.attr(null),
      student: this.belongsTo(Student, 'student_id'),
      accepted_at: this.attr(null),
      created_at: this.attr(null),
      currently_working_lessons: this.string(''),
      completed_lessons: this.attr(null),
      completed_lessons_name: this.attr(null)
    }
  }
}
